<template>
  <div class="container-fluid">

    <div class="mt-3">
      <el-steps :active="tabSelectedIndex" align-center="">
        <template v-for="(tab, i) in tabs">
          <el-step :key="i" :title="tab.name" :status="tab.status"></el-step>
        </template>
      </el-steps>
    </div>

    <hr>

    <form-venda-cobranca alias="Assinatura" :data="getDataAssinatura" v-show="tabSelectedIndex == 0" />
    <form-venda-endereco alias="Endereço" :data="getDataToAddress" v-show="tabSelectedIndex == 1" />
    <form-venda-dados alias="Dados" :data="getDataToDados" v-show="tabSelectedIndex == 2" />

    <form-venda-finalizar v-show="tabSelectedIndex == 3" :data="getDataObservacoes" :confirm="allTabsIsValid" @success="onFinish" :hasAuditoria="false" :tabulacoes="tabulacoes" :hasProvidencia="hasProvidencia" />

    <hr class="mt-4">

    <div class="row mb-4">
      <div class="col-md-4 mt-2">
        <button class="btn btn-sm btn-outline-info btn-block" :class="{'disabled': tabSelectedIndex == 0}" @click.prevent="prevTab()"><i class="fa fa-history"></i> {{ whoPrevTab }}</button>
      </div>

      <div class="col-md-4 mt-2" >
        <button @click.prevent="onClickListenerClear" class="btn btn-sm btn-outline-danger btn-block">CANCELAR <i class="fa fa-times"></i> </button>
      </div>

      <div class="col-md-4 mt-2" v-show="tabSelectedIndex < tabs.length">
        <button class="btn btn-sm btn-outline-primary btn-block" @click.prevent="nextTab()">{{ whoNextTab }} <i class="fa fa-angle-double-right"></i> </button>
      </div>

      <div class="col-md-4 mt-2" v-show="tabSelectedIndex == tabs.length">
        <button @click.prevent="onClickListenerConfirm" class="btn btn-sm btn-success btn-block">CONFIRMAR ASSINATURA <i class="fa fa-check"></i> </button>
      </div>

    </div>

  </div>
</template>
<script>

// import 'assets/js/bank-validator'

import { mapState } from 'vuex'

export default {
  name: 'FormVenda',

  components: {
    FormVendaDados: () => import('./FormVendaDados.vue'),
    FormVendaEndereco: () => import('./FormVendaEndereco.vue'),
    FormVendaCobranca: () => import('./FormVendaCobranca.vue'),
    FormVendaFinalizar: () => import('./FormVendaFinalizar.vue'),
  },

  props: {
    contact: {
      type: Object
    },

    tabulacoes: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      tabSelectedIndex: 0,

      tabs: [
        { name: "Assinatura", status: "wait", valid: false },
        { name: "Endereço", status: "wait", valid: false },
        { name: "Dados", status: "wait", valid: false }
      ]
    };
  },

  mounted() {
    this.$store.commit("cleanSale", {})
    this.tabs[0].status = "processing"

    this.$bus.$on("proposta-success", this.onFinish)
    this.$bus.$on("tabFormIsValid", this.formIsValid)

    this.$bus.$on("proposta-retorno", () => {
      this.tabSelectedIndex = 0
      this._initStateTabs()
    });

    this.$bus.$emit('proposta-has-centercob', this.getDataToAddress.cep)

    setTimeout(() => {
      this.$emit("mounted", {});
    }, 1000);
  },

  beforeDestroy() {
    this.$bus.$off("proposta-success");
    this.$bus.$off("tabFormIsValid");
    this.$bus.$off("proposta-retorno");
    this.$bus.$off("eventTeste");
  },

  computed: {
    ...mapState({

      getUser: state => state.user

    }),

    getComponent(){
      const [ compoment ] = tabs.filter(tab => tab.index === this.tabSelectedIndex)
      return compoment
    },

    hasProvidencia(){
      return this.getUser.providencia === 1
    },

    getContact() {
      return this.contact ? this.contact : {};
    },

    getDataToDados() {
      let telefones = (this.getContact.telefones || [])
        .map(tel => `${tel.ddd}${tel.telefone}`)
        .filter(tel => tel != this.getContact.telefone)

      return {
        codCob: this.getContact.codCob || null,
        cdPessoa: this.getContact.cdPessoa || null,
        documento: (this.getContact.documento || "").trim(),
        nomeRazao: this.getContact.nome || "",
        sexo: (this.getContact.sexo || "").substr(0, 1),
        fonte: (this.getContact.fonte || ""),
        email: this.getContact.email || "",
        telefone1: this.getContact.telefone,
        telefone2: telefones[0] || '',
        telefone3: telefones[1] || '',
        telefone4: telefones[2] || '',
        dataNascimento: this.getContact.nasc || "",
        origemMailing: this.getContact.mailingId || 7,
        idContato: this.getContact.id || 0,
        codCad: this.getContact.codCad || null,
        idTratamento: this.getContact.idTratamento || null
      };
    },

    getDataToAddress() {
      return {
        cep: this.getContact.cep || "",
        numero: this.getContact.numero || "",
        complemento: this.getContact.compl || "",
        cidade: this.getContact.cidade || "",
        bairro: this.getContact.bairro || "",
        logradouro: this.getContact.logr || "",
        estado: this.getContact.estado || ""
      };
    },

    getDataAssinatura(){
      return {
        nomeRazao: this.getContact.nome || "",
        idContato: this.getContact.id || 0,
        email: this.getContact.email || ""
      }
    },

    getDataObservacoes(){
      return Object.assign([{ observacao: this.getContact.newObs || '' }], this.getContact.observacoes).filter(obs => obs.observacao)
    },

    whoPrevTab() {
      let tab = this.tabs[this.tabSelectedIndex - 1];
      return (tab ? tab.name : this.tabs[this.tabSelectedIndex].name).toUpperCase();
    },

    whoNextTab() {
      let tab = this.tabs[this.tabSelectedIndex + 1];
      return (tab ? tab.name : "Revisar").toUpperCase();
    },

    allTabsIsValid() {
      return this.tabs.filter(tab => !tab.valid).length === 0;
    },

    notVendedor() {
      return this.getUser.level != "VENDEDOR";
    }
  },

  methods: {

    _showNotify(title, message, type) {
      this.$notify({ title, message, type, offset: 20 });
    },

    _emitBilhetagem(proposta) {
      let bilhetagem = {
        mailingId: this.getContact.mailingId,
        id: this.getContact.id,
        telefone: this.getContact.telefone,
        tabulacaoTipo: proposta.tabulacaoTipo,
        tabulacaoId: proposta.tabulacaoId,
        tabulacaoMotivoId: proposta.tabulacaoMotivoId,
        queue: this.getContact.queue,
        callId: this.getContact.callId,
        fonte: this.getContact.fonte
      };

      this.$bus.$emit("onFinish", { bilhetagem });
    },

    _initStateTabs() {
      this.tabs = [
        { name: "Dados", status: "wait", valid: false },
        { name: "Endereço", status: "wait", valid: false },
        { name: "Assinatura", status: "wait", valid: false }
      ];
    },

    onClickListenerConfirm() {
      if (this.allTabsIsValid) {
        this.$confirm(
          "Deseja confirmar o envio desta Proposta?",
          "CONFIRMAR PROPOSTA",
          {
            confirmButtonText: "CONFIRMAR",
            cancelButtonText: "CANCELAR"
          }
        )
          .then(confirm => {
            this.$bus.$emit("proposta-confirm", {});
          })
          .catch(_ => {});
      } else {
        this._showNotify(
          `Formulário Incompleto.`,
          `Existem campos obrigatórios não preenchidos. Preencha todos os campos e tente novamente.`,
          "error"
        );
      }
    },

    onClickListenerClear() {
      this.$confirm(
        "Deseja cancelar o preenchimento desta ficha e iniciar uma nova?",
        "CANCELAR PREENCHIMENTO",
        {
          confirmButtonText: "SIM, cancelar.",
          cancelButtonText: "NAO"
        }
      )
        .then(confirm => {
          this.tabSelectedIndex = 0;
          this._initStateTabs();

          this.$store.commit("cleanSale", {});
          this.$bus.$emit("proposta-clear", {});

          this.$bus.$emit("modal-close", {});
        })
        .catch(cancel => {});
    },

    onFinish(proposta) {
      this._emitBilhetagem(proposta);

      this.tabSelectedIndex = 0;
      this._initStateTabs();

      this.$store.commit("cleanSale", {});
      this.$bus.$emit("proposta-clear", {});

      if (this.notVendedor) {
        this.$bus.$emit("updateHeader", {});
        this._showNotify(
          "Proposta Finalizada.",
          "Sua proposta foi salva com sucesso!",
          "success"
        );
      }

      this.$bus.$emit("modal-close", {});
    },

    formIsValid(form) {
      this.tabs = this.tabs.map(item => {
        if (item.name == form.name) {
          item.valid = form.valid
          item.status = form.valid ? 'success' : 'error'
        }
        return item
      });
    },

    prevTab() {
      if (this.tabSelectedIndex > 0) this.changeTab(--this.tabSelectedIndex);
    },

    nextTab() {
      if (this.tabSelectedIndex < this.tabs.length)
        this.changeTab(++this.tabSelectedIndex);
    },

    changeTab(index) {
      for (let tab of this.tabs) this.$bus.$emit(`what-status-${tab.name}`, {})
      if (index > 0) {
        this.$bus.$emit(`what-status-${this.tabs[index - 1].name}`, {});
      }

      this.tabs.forEach((item, i) => {
        if (i == index) {
          item.status = 'processing'
        } else if (i > index) {
          item.status = 'wait'
          this.tabs[i].valid = false
        }
      })
      this.tabSelectedIndex = index
    }
  }
};
</script>

<style >
.el-radio.is-bordered+.el-radio.is-bordered {
    margin-left: 0 !important;
}
</style>



// WEBPACK FOOTER //
// FormVenda.vue?9a096d04